import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import InputRow from "./InputRow";
import PropTypes from "prop-types";
import { emailCheck, pwdCheck } from "../constants";
import submit from "../submit.gif";
import logo from "../logo.png";
import "../Main.css";
import Payment from "./Payment";
import { Redirect } from "react-router-dom";
async function CallApis() {
  const query = new URLSearchParams(window.location.search);

  const success = query.get("status");
  const mid = query.get("MID");
  // const id = query.get("id");
  // const amount_cents = query.get("amount_cents");
  // const profile_id = query.get("profile_id");
  // const email = sessionStorage.getItem("email");

  // if ((success = "true")) {
  //   this.setState({
  //     error: "Your application has been submitted successfully",
  //     color: "green",
  //     submitLoading: false,
  //     disable: true,
  //   });
  //   this.setState({
  //     error: "",
  //     color: "green",
  //     submitLoading: false,
  //     disable: true,
  //   });
  // } else {
  //   return <Redirect to="/payment" />;
  // }
  /*fetch(`${process.env.REACT_APP_API_URL}/api/submit/SubmitPayment`, {
    method: 'POST',
    body: JSON.stringify({
      success: success,
      order: order,
      id: id,
      amount_cents: amount_cents,
      profile_id: profile_id,
      email: email
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(res => {
      if (res.StatusCode === 200) {
        alert('f')

      } else {
        return <Redirect to="/payment" />
      }
    })
    .catch((err) => {
    })*/
}
export default class PaymentResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pwd: "",
      error: "",
      errorColor: "red",
      processing: false,
      resetProcessing: false,
      responsing: "<div></div>",
      falseorno: null,
      // isActive:false
    };
    //this.handleLogin = this.handleLogin.bind(this)
    //this.resetPassword = this.resetPassword.bind(this)
  }

  componentDidMount() {
    /*const id = sessionStorage.getItem('id')
    const token = sessionStorage.getItem('token')
    CallApis()
    //alert(token)
    if (id && token) {
      const { history } = this.props
      
      //history.replace('/payment')
    }*/

    const query = new URLSearchParams(window.location.search);

    const success = query.get("status");
    const mid = query.get("MID");

    //const order = query.get('order')
    ///const id = query.get('id')
    //const amount_cents = query.get('amount_cents')
    //const profile_id = query.get('profile_id')
    //const email = sessionStorage.getItem('email')
    //const govID1 = sessionStorage.getItem('govID')

    fetch(`${process.env.REACT_APP_API_URL}/api/submit/SubmitPayment`, {
      method: "POST",
      body: JSON.stringify({
        STAT: success,
        MID: mid,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          alert("You have successfully paid for your application");
          sessionStorage.clear();

          window.location.href = "/InternationalPostGradAppForm/login";
        } else {
          alert(
            "Your payment has failed. Please log in again to complete your payment."
          );
          sessionStorage.clear();
          window.location.href = "/InternationalPostGradAppForm/login";
        }
      })
      .catch((err) => {
        this.setState({
          error: "Something went wrong",
          processing: false,
          pwd: "",
        });
        console.log(err);
      });

    // if (success == "success") {
    //   this.setState({
    //     error: "You have successfully paid for your application",
    //     color: "green",
    //   });
    // } else {
    //   this.setState({ error: "Your payment failed", color: "red" });
    // }

    this.forceUpdate();
  }

  render() {
    const { error, color } = this.state;
    return (
      <div id="mainContainer">
        <div id="designBorder"></div>

        <div id="main-page">
          <div className="sources-section">
            <label style={{ color: color }}>{error}</label>
          </div>
        </div>
      </div>
    );
    //return <Redirect to="/payment"/>

    return <div></div>;
  }
}
PaymentResult.propTypes = {
  //onLogin: PropTypes.func.isRequired,
  history: PropTypes.object,
};
